import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  width: '100%',
  columnGap: '24px',
  rowGap: '4px',
  paddingTop: '24px',
});
